/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getFormValues, isDirty, isValid } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { get } from 'lodash';

import styles from './styles.module.scss';
import UsageInfo from '../WorklistShow/UsageInfo';
import WorklistHeader from '../WorklistShow/WorklistHeader';
import ActionButton from '../../../components/ActionButton';
import DataLoader from '../../../components/DataLoader';
import Divider from '../../../components/Divider';
import Modal from '../../../components/Modal';
import ProductionForm from '../../../forms/ProductionForm';
import actions from '../../../redux/actions';
import { getWorklist } from '../../../redux/reducers/worklists';
import domUtils from '../../../utils/dom';
import protonesUtils from '../../../utils/protones';

import type {
  Translate,
  ReactRouterProps,
  Fetchable,
  Worklist,
  SaveWorklistParams,
  SaveProductionParams,
  ReduxState,
} from '../../../types';

const mapStateToProps = (state: ReduxState, ownProps) => {
  const worklistId = ownProps.match.params.worklistId;
  const isNew = worklistId === 'create';
  return {
    headerFormValues: getFormValues('worklistHeader')(state),
    headerFormDirty: isDirty('worklistHeader')(state),
    headerFormValid: isValid('worklistHeader')(state),
    usageFormValues: getFormValues('worklistUsage')(state),
    usageFormDirty: isDirty('worklistUsage')(state),
    usageFormValid: isValid('worklistUsage')(state),
    worklistId,
    worklist: getWorklist(state),
    isNew,
    ...ownProps,
  };
};

type Props = ReactRouterProps & {
  headerFormValues: Object,
  headerFormDirty: boolean,
  headerFormValid: boolean,
  usageFormValues: Object,
  usageFormDirty: boolean,
  usageFormValid: boolean,
  worklistId?: string,
  worklist: Fetchable<Worklist>,
  isNew: boolean,
  saveWorklist: typeof actions.saveWorklist,
  fetchWorklistList: typeof actions.fetchWorklistList,
  saveProduction: typeof actions.saveProduction,
  t: Translate,
};

type State = {
  isProductionModalVisible: boolean,
};

class WorklistEdit extends React.Component<Props, State> {
  state = {
    isProductionModalVisible: false,
  };

  _handleSaveWorklist = () => {
    const {
      headerFormDirty,
      headerFormValid,
      headerFormValues,
      usageFormDirty,
      usageFormValid,
      usageFormValues,
      t,
    } = this.props;
    if ((headerFormDirty && headerFormValid) || (usageFormDirty && usageFormValid)) {
      const params: SaveWorklistParams = {
        name: get(headerFormValues, 'name', t('WORKLIST')),
        description: get(headerFormValues, 'description', t('NO_DESCRIPTION')),
        usage: protonesUtils.getUsageUpdateParamsFromObject(usageFormValues),
      };
      this.props.saveWorklist(params, (worklist: Worklist) => {
        protonesUtils.goTo(this.props, protonesUtils.routes.worklists.get(worklist.id));
      });
    }
  };

  _getWorklistFormTitle() {
    const {
      worklist: { data },
      isNew,
      t,
    } = this.props;
    if (isNew) {
      return t('DEFINE_NEW_WORKLIST');
    } else if (data && data.name) {
      return data.name;
    }
  }

  _openProductionModal = () => {
    this.setState({ isProductionModalVisible: true });
  };

  _dismissProductionModal = () => {
    this.setState({ isProductionModalVisible: false });
  };

  _handleProductionCreate = async (params: SaveProductionParams) => {
    this._dismissProductionModal();
    await this.props.saveProduction(params);
    domUtils.refreshCurrentPage();
  };

  _renderFormData = data => {
    const { t } = this.props;
    const { isProductionModalVisible } = this.state;
    const worklistParams: SaveWorklistParams = protonesUtils.getWorklistSaveParamsFromWorklist(
      data
    );

    return (
      <div className={styles.content}>
        <div className={styles.actionButtons}>
          <ActionButton iconName={'close'} onClick={this.props.history.goBack} />
        </div>
        {/* <WorklistForm
          initialValues={initialValues}
          isLoading={fetching}
          title={this._getWorklistFormTitle()}
          save={this._handleSaveWorklist}
        /> */}
        <WorklistHeader
          // imgSrc={imgSrc}
          {...worklistParams}
          onSave={this._handleSaveWorklist}
          // onPublish={() => this._handlePublishWorklist(data.id)}
          // onArchive={() => this._handleArchiveWorklist(data.id)}
          // onDelete={() => this._handleDeleteWorklist(data.id)}
          // onSelectAsWorklist1={
          //   !data.isWorklist1 ? () => this._handleSetWorklist1(data.id) : undefined
          // }
          // onSelectAsWorklist2={
          //   !data.isWorklist2 ? () => this._handleSetWorklist2(data.id) : undefined
          // }
        />
        <Divider />
        <UsageInfo
          {...worklistParams.usage}
          // onSaveAsPreset={this._openSavePresetModal}
          onCreateProduction={this._openProductionModal}
        />
        {!!isProductionModalVisible && (
          <Modal title={t('CREATE_NEW_PRODUCTION')} onDismiss={this._dismissProductionModal}>
            <ProductionForm
              isCreate={true}
              // title={''}
              // isLoading={false}
              save={this._handleProductionCreate}
            />
          </Modal>
        )}
      </div>
    );
  };

  render() {
    const {
      worklist: { fetching, error, data },
    } = this.props;
    return (
      <DataLoader
        loading={fetching}
        error={error}
        data={data}
        render={this._renderFormData}
        fallback={this._renderFormData}
      />
    );
  }
}

export default withTranslation()(
  withRouter(
    connect(
      mapStateToProps,
      actions
    )(WorklistEdit)
  )
);
